var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-header-bar", attrs: { "data-testid": _vm.testId } },
    [
      _vm.isMobile(_vm.$mq) && !_vm.clientType.is_native
        ? _c("div", [
            _c(
              "header",
              { staticClass: "m-action-bar", attrs: { id: "m-action-bar" } },
              [
                _c("HeaderLinks", { staticClass: "m-tab-bar" }, [
                  !_vm.user.is_authenticated
                    ? _c(
                        "div",
                        {
                          staticClass: "hdr-logo",
                          attrs: {
                            slot: "logo",
                            "data-testid": _vm.testId + "_logo"
                          },
                          slot: "logo"
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "b-sprite-global-brilliant-logo-full-black",
                              attrs: { to: { name: "homepage" } }
                            },
                            [_vm._v("\n            Brilliant\n          ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile(_vm.$mq)
        ? _c(
            "header",
            {
              staticClass: "site-header",
              class: { "refreshed-navbar": _vm.refreshedNavbarExperiment },
              attrs: { id: "header" }
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c("HeaderLinks", { staticClass: "hdr-links" }, [
                    _c(
                      "div",
                      {
                        staticClass: "hdr-logo",
                        attrs: {
                          slot: "logo",
                          "data-testid": _vm.testId + "_logo"
                        },
                        slot: "logo"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "b-sprite-global-brilliant-logo",
                            attrs: {
                              to: {
                                name: _vm.user.is_authenticated
                                  ? "userhome"
                                  : "homepage"
                              }
                            }
                          },
                          [_vm._v("\n            Brilliant\n          ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.user.is_authenticated
                      ? _c(
                          "div",
                          {
                            staticClass: "hdr-search",
                            attrs: { slot: "search" },
                            slot: "search"
                          },
                          [
                            _c("SearchWidget", {
                              attrs: {
                                "is-staff-user": _vm.user.is_staff,
                                mobile: _vm.mobile,
                                "analytics-identity": _vm.identity,
                                "highlight-search": false,
                                "in-header": true,
                                "algolia-proxy-url": _vm.algoliaProxyUrl,
                                testIdPrefix: _vm.testId,
                                "input-element-key": "header-search"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.messages ? _c("DjangoMessages") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }